export enum MotionModeString {
  AUTO = 0,
  TRIGGER_FORCE = 1,
  AAN = 2,
  AAN2 = 3,
}

export enum MotionModeCode {
  AUTO = 'auto',
  TRIGGER_FORCE = 'int',
  AAN = 'aan1',
  AAN2 = 'aan2',
  ZERO_FORCE = 'zf',
  EEG = 'eeg',
}

export enum WalkDirection {
  FORWARD = 0,
  BACKWARD = 1,
}

export enum WalkDirectionCode {
  FORWARD = 'fwd',
  BACKWARD = 'bwd',
}

export enum DeviceModelCode {
  ATLAS = 5,
  EXPLORER_PERSONAL = 6,
  EXPLORER_CLINICO = 7,
}

export enum AtlasState {
  STOPPED = 0,
  WALKING = 1,
  SITTING = 2,
  SIT = 3,
  STANDING = 4,
  STAND = 5,
  BEGIN_WALK = 6,
  END_WALK = 7,
}

export enum ExplorerState {
  DISABLED = 0,
  WALKING = 1,
  SITTING = 2,
  INITIALIZING = 3,
  STANDING = 4,
  ENABLED = 5,
  BEGIN_WALK = 6,
  END_WALK = 7,
  TRIGGERING_BY_FORCE = 8,
  ELEVATION_DOWN = 9,
  ELEVATION_UP = 10,
}

export enum ExplorerClinicState {
  DISABLED = 0,
  WALKING = 1,
  SITTING = 2,
  INITIALIZING = 3,
  STANDING = 4,
  ENABLED = 5,
  BEGIN_WALK = 6,
  END_WALK = 7,
  TRIGGERING_BY_FORCE = 8,
  ELEVATION_DOWN = 9,
  ELEVATION_UP = 10,
  WALKING_AAN = 11,
  ZERO_FORCE = 12,
  WALKING_AAN_ZF = 13,
}

export enum AlarmType {
  WARNING = 0,
  ERROR = 1,
  MNT = 2,
}

export enum Corset {
  SMALL_FLAT = 'pages.maintenance.ingestion.corseSC',
  SMALL_CURVE = 'pages.maintenance.ingestion.corseSE',
  BIG_FLAT = 'pages.maintenance.ingestion.corseLC',
  BIG_CURVE = 'pages.maintenance.ingestion.corseLE',
}

export const CORSET_BY_CODE = [
  Corset.SMALL_FLAT,
  Corset.SMALL_CURVE,
  Corset.BIG_FLAT,
  Corset.BIG_CURVE,
] as const;

export enum IntrasessionView {
  VITALS = 'VITALS',
  AUTO = 'AUTO',
  TRIGGER_FORCE = 'TRIGGER_FORCE',
  AAN = 'AAN',
}
export const INTRASESSION_VIEWS = [
  IntrasessionView.VITALS,
  IntrasessionView.AUTO,
  IntrasessionView.TRIGGER_FORCE,
  IntrasessionView.AAN,
] as const;

export enum DeviceModelType {
  ATLAS = 5,
  EXPLORER_PERSONAL = 6,
  EXPLORER_CLINICO = 7,
  ALL_DEVICES = 1,
}

export const deviceLabels = [
  { value: DeviceModelType.ATLAS, label: 'Atlas' },
  { value: DeviceModelType.EXPLORER_PERSONAL, label: 'Explorer Personal' },
  { value: DeviceModelType.EXPLORER_CLINICO, label: 'Explorer Clinico' },
  { value: DeviceModelType.ALL_DEVICES, label: 'Todos los dispositivos' },
];


const LABEL_BY_MODEL = new Map<number, string>(
  deviceLabels.map(({ value, label }) => [value, label])
);

export const getDeviceLabel = (model: unknown): string | undefined => {
  const value = Number(model);
  if (!Number.isFinite(value) || value === DeviceModelType.ALL_DEVICES) {
    return undefined;
  }
  return LABEL_BY_MODEL.get(value);
};

